import { addDays, differenceInDays, format } from "date-fns";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import STEP from "../constants/STEP";
import useFetchTaxes from "../hooks/useFetchTaxes";
import useMail from "../hooks/useMail";
import { dateToString, stringToDate } from "../mapping/taxMapping";
import { getUserId, getUserName } from "../services/auth";
import { createBudget } from "../services/budgetService";
// import { createCallStatus } from "../services/callCenterService";
import useBudgetRequestCallCenter from "../hooks/useBudgetRequestCallCenter";
import useBudgetRequestCanalDireto from "../hooks/useBudgetRequestCanalDireto";
import { sendEmail, sendEmailTemplate } from "../services/emailService";
import { sendMessage } from "../services/messageService";
import generateUniqueHash from "../utils/generateUniqueHash";
import { createDatesArr } from "../utils/utils";
const _ = require("lodash");
//const defaultTax = 7.25 / 100;

export const verifyRuleApplies = (dates, rule) => {
  if (!dates?.length || !rule) return false;

  const ruleDates = Object.keys(rule).filter((key) => typeof rule[key] === 'object' && rule[key] !== null);
  if (dates.length < (rule[ruleDates[0]]?.number_min_nights || 0)) return false;
  return ruleDates.filter((ruleDate) => dates.includes(ruleDate)).length > 0;
};

const rulesCase = {
    verify: verifyRuleApplies,
    apply: (dates, rule, prices) => {
      const getDate = (rule) =>
          rule[dates[0]]?.flag_nights_free === "PRI" ? dates[0] : dates[dates.length - 1];

      return rule[dates[0]]?.flag_nights_free === 'PRI' ||  rule[dates[0]]?.flag_nights_free === 'ULT'?
          {
            value:
              prices[getDate(rule)]?.daily_price * 1.0725 //1.0725 = hotel tax

          } : {
            percentual:
              _.sum(dates.map((date) => {
                if(rule[date]?.perc_discount) {
                  return (prices[date]?.daily_price * 1.0725) * (rule[date]?.perc_discount / 100) //1.0725 = hotel tax
                } else {
                  return 0
                }              
              })),
          }
    },

  "5x4 1A NOITE FREE": {
    verify: (dates, rule) => {
      const beforeDayBeginPeriod = dateToString(
        addDays(stringToDate(dates[0]), -1)
      );
      const afterDayEndPeriod = dateToString(
        addDays(stringToDate(dates[dates.length - 1]), 1)
      );
      if (rule[beforeDayBeginPeriod] || rule[afterDayEndPeriod]) return false;

      return dates.every((date) => rule[date]?.number_nights_free);
    },
    apply: (dates, rule, prices) => {
      const getDate = (rule) =>
        rule.flag_nights_free === "PRI" ? dates[0] : dates[dates.length - 1];

      const daily_discount = prices[getDate(rule)]?.daily_price || 0;

      return {
        discount:
          (100 * daily_discount) /
          _.sum(dates.map((date) => prices[date]?.daily_price || 0)),
      };
    },
  },
  "7x6- 1ª NOITE FREE teste": {
    verify: (dates, rule) => {
      const beforeDayBeginPeriod = dateToString(
        addDays(stringToDate(dates[0]), -1)
      );
      const afterDayEndPeriod = dateToString(
        addDays(stringToDate(dates[dates.length - 1]), 1)
      );
      if (rule[beforeDayBeginPeriod] || rule[afterDayEndPeriod]) return false;

      return dates.every((date) => rule[date]?.number_nights_free);
    },
    apply: (dates, rule, prices) => {
      const getDate = (rule) =>
        rule.flag_nights_free === "PRI" ? dates[0] : dates[dates.length - 1];

      const daily_discount = prices[getDate(rule)]?.daily_price || 0;

      return {
        discount:
          (100 * daily_discount) /
          _.sum(dates.map((date) => prices[date]?.daily_price || 0)),
      };
    },
  },
  "4RN -5%": {
    verify: verifyRuleApplies,
    apply: (dates, rule) => ({
      discount:
        _.sum(dates.map((date) => rule[date]?.perc_discount || 0)) /
        dates.length,
    }),
  },
  "4RN -10%": {
    verify: verifyRuleApplies,
    apply: (dates, rule) => ({
      discount:
        _.sum(dates.map((date) => rule[date]?.perc_discount || 0)) /
        dates.length,
    }),
  },
  "5RN -10%": {
    verify: verifyRuleApplies,
    apply: (dates, rule) => ({
      discount:
        _.sum(dates.map((date) => rule[date]?.perc_discount || 0)) /
        dates.length,
    }),
  },
  "6RN -10%": {
    verify: verifyRuleApplies,
    apply: (dates, rule) => ({
      discount:
        _.sum(dates.map((date) => rule[date]?.perc_discount || 0)) /
        dates.length,
    }),
  },
  "7RN -10%": {
    verify: verifyRuleApplies,
    apply: (dates, rule) => ({
      discount:
        _.sum(dates.map((date) => rule[date]?.perc_discount || 0)) /
        dates.length,
    }),
  },
};

var priceRuleFreeNightPRI = 0;
var priceRuleFreeNightFIM = 0;

const rulesCaseDaily = {
  apply: (dates, rule, prices) => {
    const getDate = (rule) =>
        rule[dates[0]]?.flag_nights_free === "PRI" ? dates[0] : dates[dates.length - 1];

    const result = rule[dates[0]]?.flag_nights_free === 'PRI' ||  rule[dates[0]]?.flag_nights_free === 'ULT'?
        {
          	value:
            	priceRuleFreeNightPRI !== 0 || priceRuleFreeNightFIM !== 0 ? 0 : prices[getDate(rule)]?.daily_price

        } : {
          	percentual:
				_.sum(dates.map((date) => {
				if(rule[date]?.perc_discount) {
					return (prices[date]?.daily_price ) * (rule[date]?.perc_discount / 100) //1.0725 = hotel tax
				} else {
					return 0
				}              
				})),
        }

		if(rule[dates[0]]?.flag_nights_free === 'PRI' && priceRuleFreeNightPRI === 0) {
		priceRuleFreeNightPRI = prices[getDate(rule)]?.daily_price || 0;
		}
		else if(rule[dates[0]]?.flag_nights_free === 'ULT' && priceRuleFreeNightFIM === 0) {
		priceRuleFreeNightFIM = prices[getDate(rule)]?.daily_price || 0;
		}

		return result
  },
};

//Valores iniciais do contexto global
export const BudgetFormContextDefaultValues = {
  params: {
    check_in: new Date(),
    check_out: new Date(),
    adults_quantity: 2,
    children_quantity: 1,
    babies_quantity: 0,
  },
  data: { dates: [], tax: [], prices: [], rules: [], tematicas: [], prices_daily: [], payment_types: [] },
  checkedRules: {},
  selectedDates: [],
  fetchData: () => {},
  setRange: () => {},
  setSelectedDates: () => {},
  setCheckedRules: () => {},
};

//Instância do contexto, recebendo os valores iniciais
export const BudgetFormContext = createContext(BudgetFormContextDefaultValues);

//Provedor que é resposável pela manipulação e controle do estado
const BudgetFormContextProvider = ({ children, setIsForm, isForm }) => {
  const [selectedPrices, setSelectedPrices] = useState([]);
  const [selectedPricesDaily, setSelectedPricesDaily] = useState([]);
  const [addedPrices, setAddedPrices] = useState([]);
  const [addedPricesDaily, setAddedPricesDaily] = useState([]);
  const [selectedPricesOut, setSelectedPricesOut] = useState([]);
  const [basePricesOut, setBasePricesOut] = useState([]);
  const [selectedPricesDailyOut, setSelectedPricesDailyOut] = useState([]);
  const [extras, setExtras] = useState(0);
  const [loading, setLoading] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [budgets, setBudgets] = useState([]);
  const [params, changeParams] = useState(
    BudgetFormContextDefaultValues.params
  );
  const [checkedRules, setCheckedRules] = useState({});
  const [selectedDates, setSelectedDates] = useState([]);
  const formType = isForm;

  const [step, setStep] = useState(STEP.BUDGET);

  const { data, fetchData } = useFetchTaxes();
  const { mail, changeMail } = useMail();
  const { budgetRequest, changeBudgetRequestForm } = useBudgetRequestCallCenter();
  const { budgetRequestCanalDireto, changeBudgetRequestFormCanalDireto } = useBudgetRequestCanalDireto();
  const [discountInput, setDiscountInput] = useState(0);
  const [percDiscount, setPercDiscount] = useState(0);
  const [hashBudgets, setHashBudgets] = useState(generateUniqueHash());

  const stayLength = useMemo(() => {
    return differenceInDays(params.check_out, params.check_in);
  }, [params.check_in, params.check_out]);

  useEffect(() => {
    if (budgets.length > 0) {
      setHashBudgets(generateUniqueHash());
    }

  }, [budgets]);

  const stop = 1,
        fecho = 2,
        fecho_in = 3,
        fecho_out = 4;

  // useEffect(() => {
  //   setSelectedDates(_.take(_.drop(data.dates, 15), 15));
  // }, [_, data.dates]);

  const paymentTypes = data?.payment_types || [];

  const defaultPercentualDiscount = 0.95;
  const defaultDiscount = 5;

  const nonRefundablePercentualDiscount = 0.93;
  const nonRefundableDiscount = 7;

  // Politica nao reembolsável pix
  const pixType = paymentTypes.find(
    (p) => Number(p.id) === 4
  );
  const pixPct = Number(
    pixType?.percentage_discount ??
    nonRefundablePercentualDiscount
  );
  const nonRefundablePercentualDiscountPix = pixPct;
  const nonRefundableDiscountPix = Math.round(
    (1 - pixPct) * 100
  );

  // Politica nao reembolsável cartão
  const cardType = paymentTypes.find(
    (p) => Number(p.id) === 5
  );
  const cardPct = Number(
    cardType?.percentage_discount ??
    defaultPercentualDiscount
  );
  const nonRefundablePercentualDiscountCard = cardPct;
  const nonRefundableDiscountCard = Math.round(
    (1 - cardPct) * 100
  );

  const lowestPossibleCategory = useMemo(() => {
    if (!selectedDates.length || !data.pricesByCategoria) return null;

    const categories = Object.keys(data.pricesByCategoria).filter(cat => data.pricesByCategoria[cat]?.length > 0);
    if (categories.length === 0) return null;

    const sortedCategories = categories.sort((a, b) => Number(a) - Number(b));

    return sortedCategories[0];
  }, [selectedDates, data.pricesByCategoria, data.prices]);

  const activeCategory = useMemo(() => {
    if (!selectedDates.length || !data.pricesByCategoria) return null;

    const categorias = [1, 2, 3];

    for (const categoria of categorias) {
      const categoryPrices = data.pricesByCategoria[categoria];

      if (!categoryPrices?.length) continue;

      const hasAvailableUh = categoryPrices.some((uh) => {
        const firstDate = selectedDates[0];

        const lastDateParts = selectedDates[selectedDates.length - 1].split("/");
        const lastDate = new Date(+lastDateParts[2], lastDateParts[1] - 1, +lastDateParts[0]);

        const checkoutDate = format(addDays(lastDate, 1), 'dd/MM/yyyy');

        return selectedDates.every((date) => {
          const dayData = uh[date];
          if (!dayData) return false;

          const restriction = dayData.restriction_type;

          const minRoomNights = Number(dayData.min_room_nights || 0);

          // if (stayLength < minRoomNights) {
          //   return false;
          // }

          if (restriction === stop) return false;

          if (date === firstDate && (restriction === fecho_in || restriction === fecho)) return false;

          return true;
        }) && (() => {
          const checkoutDay = uh[checkoutDate];
          if (!checkoutDay) return true;

          return checkoutDay.restriction_type !== fecho_out && checkoutDay.restriction_type !== fecho;
        })();
      });

      if (hasAvailableUh) return categoria;
    }

    return null;
  }, [selectedDates, data.pricesByCategoria]);

  const previousCategoriesPrices = useMemo(() => {
    if (!activeCategory || !data.pricesByCategoria) return [];

    const categorias = [1, 2, 3];

    return categorias
      .filter((cat) => cat < activeCategory)
      .flatMap((cat) => data.pricesByCategoria[cat] || []);
  }, [activeCategory, data.pricesByCategoria]);

  const pricesToProcess = useMemo(() => {
    if (!activeCategory) return data.prices || [];

    return data.pricesByCategoria[activeCategory] || [];
  }, [activeCategory, data.pricesByCategoria, data.prices]);

  const hotelTax = 1.0725;
  useEffect(() => {
    if (selectedDates.length === 0) return;
    
    const baseDiscount = percDiscount > 0 ? ((100 - percDiscount) / 100) : 1
    const manualDiscountFraction = percDiscount > 0 ? percDiscount / 100 : 0;
    
    const ruledDiscount = percDiscount > 0 ? ((100 - percDiscount) / 100) * defaultPercentualDiscount : defaultPercentualDiscount

    const ruledNonRefundableDiscount = percDiscount > 0 ? ((100 - percDiscount) / 100) * nonRefundablePercentualDiscount : nonRefundablePercentualDiscount

    const ruledNonRefundableDiscountCard = percDiscount > 0 ? ((100 - percDiscount) / 100) * nonRefundablePercentualDiscountCard : nonRefundablePercentualDiscountCard

    const ruledNonRefundableDiscountPix = percDiscount > 0 ? ((100 - percDiscount) / 100) * nonRefundablePercentualDiscountPix : nonRefundablePercentualDiscountPix

    const groupedPrices = [];
    const groupedPricesOut = []; 
    const addedDailyPrices = [];
    const addedGroupedPrices = [];
    const dailyPrices = [];
    const dailyPricesOut = [];

    let groupedDiscounts = {};

    pricesToProcess.forEach((item) => {
    	priceRuleFreeNightPRI = 0
	    priceRuleFreeNightFIM = 0

      const categoria = item[selectedDates[0]]?.categoria;

      let currentItem = _.cloneDeep(item); 

      groupedDiscounts[item.acommodation_description] = { discount: 0 };
      
      const isStop = selectedDates.some((date) => item[date]?.restriction_type === stop);
      const hasOtherRestriction = selectedDates.some((date) => {
        const dateParts = selectedDates[selectedDates.length - 1].split("/");
        const endDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

        return (
          item[selectedDates[0]]?.restriction_type === fecho_in ||
          item[selectedDates[0]]?.restriction_type === fecho ||
          item[format(addDays(endDate, 1), 'dd/MM/yyyy')]?.restriction_type === fecho_out ||
          item[format(addDays(endDate, 1), 'dd/MM/yyyy')]?.restriction_type === fecho
        );
      });

      if (hasOtherRestriction) return;

      const currentPrice = {};
      
      let min_room_nights = 0;
      selectedDates.forEach((date)=>{
        const min_room_night = item[date]?.min_room_nights;

        if(min_room_night > min_room_nights){
          min_room_nights = min_room_night
        }
      })

      // if (stayLength < min_room_nights) {
      //   return;
      // }

      selectedDates.forEach((date) => {
        const dailyPrice = item[date]?.daily_price || 0;
        let dailyPriceForPush;
        const totalPrice = dailyPrice + (currentPrice[item.acommodation_description]?.total_daily_without_tax || 0);
      
        const priceDate = item[date]?.accomodation_date;
        const children_free = item[date]?.children_free;
        const min_room_night_children_free = item[date]?.min_room_night_children_free;
      
        currentPrice[item.acommodation_description] = {
          total_daily_without_tax: totalPrice,
          total_cost_accomodation: totalPrice,
          total_daily_with_tax: totalPrice * hotelTax, //* hotelTax,
          total_daily_with_tax_discount: totalPrice, // * hotelTax,
          total_daily_with_non_refundable_discount: totalPrice,
          total_daily_with_non_refundable_discount_pix: totalPrice,
          total_daily_with_non_refundable_discount_card: totalPrice, 
          acommodation_date: priceDate,
          children_free,
          min_room_night_children_free,
          tax_id: item[date]?.tax_id,
          flg_nao_disponivel: false,
          categoria_anterior: false,
        };
      
      const rulesDaily = data.rules
        .filter((rule) => (checkedRules[rule.rule_description]?.checked || false) && rulesCase.verify(selectedDates, rule))
        .sort((a, b) => {
          const orderA = checkedRules[a.rule_description]?.order ?? Number.MAX_SAFE_INTEGER;
          const orderB = checkedRules[b.rule_description]?.order ?? Number.MAX_SAFE_INTEGER;
        
          return orderA - orderB;
        })
        .map((rule) => {
          const nightsFreeFlag = rule[date]?.flag_nights_free;
          const isFreeNight = nightsFreeFlag === 'PRI' || nightsFreeFlag === 'ULT';
          const freeNightDate = nightsFreeFlag === 'PRI'
            ? selectedDates[0]
            : selectedDates[selectedDates.length - 1];

          if (isFreeNight && date !== freeNightDate) {
            return {
              rule,
              priceAdjustment: { value: 0 },
              priceAdjustmentValue: 0,
            };
          }

          const itemToUse = rule.flag_cumulative === 'S' ? currentItem : item;
          const priceAdjustment = rulesCaseDaily.apply([date], rule, itemToUse);

          const priceAdjustmentValue = priceAdjustment.value ? priceAdjustment.value : priceAdjustment.percentual;

          if (currentItem[date]?.daily_price !== undefined) {
            currentItem[date].daily_price -= priceAdjustmentValue;
          } else {
            console.log("currentItem.date.daily_price is undefined, no adjustment made.");
          }

          return { rule, priceAdjustment, priceAdjustmentValue };
        });
    
        const rulePercDiscount = _.sumBy(rulesDaily, "priceAdjustment.percentual") || 0;
        const ruleValueDiscount = _.sumBy(rulesDaily, "priceAdjustment.value") || 0;

        const discountValue = (rulePercDiscount > 0 ? rulePercDiscount : ruleValueDiscount)
        const ruleDiscountPercentage = dailyPrice > 0
          ? Math.min(discountValue / dailyPrice, 1)
          : 0;

        groupedDiscounts[item.acommodation_description].discount += discountValue;
    
        dailyPriceForPush = (dailyPrice - discountValue) * (1 - manualDiscountFraction);

        const dailyPriceObject = {
          acommodation_description: item.acommodation_description,
          date,
          daily_price: dailyPriceForPush,
          daily_price_with_tax: dailyPriceForPush * hotelTax,
          daily_base_price: dailyPrice,
          discount: 1 - (1 - ruleDiscountPercentage) * (1 - manualDiscountFraction),
          discounts_applied: [
            ...rulesDaily
              .filter(({ priceAdjustmentValue }) => priceAdjustmentValue !== 0)
              .map(({ rule, priceAdjustment, priceAdjustmentValue }) => {
              const isFreeNight =
                rule[date]?.flag_nights_free === 'PRI' ||
                rule[date]?.flag_nights_free === 'ULT';

              return {
                type: 'RULE',
                reference_id: rule[date]?.rule_id || null,
                discount: isFreeNight
                  ? 1
                  : priceAdjustment.value
                    ? Math.min(priceAdjustmentValue / dailyPrice, 1)
                    : ((rule[date]?.perc_discount || 0) / 100),
                total_discount: priceAdjustmentValue,
              };
              }),
            ...(manualDiscountFraction > 0
              ? [{
                  type: 'MANUAL',
                  reference_id: null,
                  discount: percDiscount / 100,
                  total_discount: (dailyPrice - discountValue) * manualDiscountFraction,
                }]
              : []),
          ],
          children_free,
          min_room_night_children_free,
          tax_id: item[date]?.tax_id,
          acommodation_id: item[date]?.uh_type_id,
        }

		if (isStop) {
			if (addedPricesDaily.find(apd => apd?.acommodation_description === dailyPriceObject?.acommodation_description)){
				addedDailyPrices.push({
					...dailyPriceObject
				});
			} else {
				dailyPricesOut.push({
					...dailyPriceObject
				});
			}
		} else {
			dailyPrices.push({
        		...dailyPriceObject
			});
		}
    });
		const finalGroupedItem = {
			...currentPrice[item.acommodation_description],
			acommodation_description: item.acommodation_description,
      categoria,
			flg_nao_disponivel: false,
      categoria_anterior: false,
		};

		if (isStop) {
			finalGroupedItem.flg_nao_disponivel = true
			if (addedPrices.find(item => item?.acommodation_description === finalGroupedItem?.acommodation_description)){
				addedGroupedPrices.push(finalGroupedItem);
			}else{
				groupedPricesOut.push(finalGroupedItem);
			}
		} else {
			groupedPrices.push(finalGroupedItem);
		}
	});

  previousCategoriesPrices.forEach((item) => {
    if (
      groupedPricesOut.some(
        (p) => p.acommodation_description === item.acommodation_description
      )
    ) return;

    const categoria = item[selectedDates[0]]?.categoria;

    let currentItem = _.cloneDeep(item);

    if (!groupedDiscounts[item.acommodation_description]) {
      groupedDiscounts[item.acommodation_description] = { discount: 0 };
    }

    const currentPrice = {};

    selectedDates.forEach((date) => {
      const dailyPrice = currentItem[date]?.daily_price || 0;

      const totalPrice =
        dailyPrice +
        (currentPrice[item.acommodation_description]?.total_daily_without_tax || 0);

      currentPrice[item.acommodation_description] = {
        total_daily_without_tax: totalPrice,
        total_cost_accomodation: totalPrice,
        total_daily_with_tax: totalPrice * hotelTax,
        acommodation_description: item.acommodation_description,
        flg_nao_disponivel: true,
        categoria_anterior: true,
      };

      dailyPricesOut.push({
        acommodation_description: item.acommodation_description,
        date,
        daily_price: dailyPrice,
        daily_price_with_tax: dailyPrice * hotelTax,
        flg_nao_disponivel: true,
        categoria_anterior: true,
      });
    });

    groupedPricesOut.push({
      ...currentPrice[item.acommodation_description],
      acommodation_description: item.acommodation_description,
      categoria,
      flg_nao_disponivel: true,
      categoria_anterior: true,
    });
  });

	const finalGroupedPrices = [...groupedPrices, ...addedGroupedPrices];

	[finalGroupedPrices, groupedPricesOut].forEach((priceGroup, index) => {
		for (let i = 0; i < priceGroup.length; i++) {
      const item = priceGroup[i];

      const price =
        item.total_daily_without_tax -
        (groupedDiscounts[item.acommodation_description]?.discount || 0);

      const baseWithTax = (price * hotelTax) + extras;

      const discountPercent = 1 - ruledDiscount;
      const discountValue = baseWithTax * discountPercent;

      item.total_daily_with_tax_discount =
        baseWithTax - (discountInput > 0 ? discountInput : discountValue);

      // const nonRefundableDiscountPercent = 1 - ruledNonRefundableDiscount;
      // const nonRefundableDiscountValue = baseWithTax * nonRefundableDiscountPercent;

      // item.total_daily_with_non_refundable_discount =
      //   baseWithTax - (discountInput > 0 ? discountInput : nonRefundableDiscountValue);

      const nonRefundableDiscountCardPercent = 1 - ruledNonRefundableDiscountCard;
      const nonRefundableDiscountCardValue = baseWithTax * nonRefundableDiscountCardPercent;

      item.total_daily_with_non_refundable_discount_card =
        baseWithTax - (discountInput > 0 ? discountInput : nonRefundableDiscountCardValue);

      const nonRefundableDiscountPixPercent = 1 - ruledNonRefundableDiscountPix;
      const nonRefundableDiscountPixValue = baseWithTax * nonRefundableDiscountPixPercent;

      item.total_daily_with_non_refundable_discount_pix =
        baseWithTax - (discountInput > 0 ? discountInput : nonRefundableDiscountPixValue);


      const baseDiscountPercent = 1 - baseDiscount;
      const baseDiscountValue = baseWithTax * baseDiscountPercent

      item.total_cost_accomodation = baseWithTax - (discountInput > 0 ? discountInput : baseDiscountValue);
      item.discount = manualDiscountFraction;
    }
	});

    groupedPricesOut.sort((a, b) => {
      if (a.categoria !== b.categoria) {
        return a.categoria - b.categoria;
      }

      if (a.categoria_anterior !== b.categoria_anterior) {
        return a.categoria_anterior ? 1 : -1;
      }

      return a.total_cost_accomodation - b.total_cost_accomodation;
    });

		const finalDailyPrices = [...dailyPrices, ...addedDailyPrices]

		setSelectedPrices(finalGroupedPrices);
		setSelectedPricesOut(groupedPricesOut);
		setSelectedPricesDaily(finalDailyPrices);
		setSelectedPricesDailyOut(dailyPricesOut);

		setBasePricesOut(groupedPricesOut);
    setAddedPrices(addedGroupedPrices);
    setAddedPricesDaily(addedDailyPrices);

 	}, [params, data, checkedRules, selectedDates, extras, discount, discountInput, percDiscount]);

	const handleAddPriceOut = useCallback((accommodationDescription) => {
		const selectedPrice = selectedPricesOut.find(
			(price) => price.acommodation_description === accommodationDescription
		);

		const selectedPriceDaily = selectedPricesDailyOut.filter(
			(price) => price.acommodation_description === accommodationDescription
		);

		if (selectedPrice && selectedPriceDaily.length > 0) {
			setSelectedPrices((prev) => [...prev, selectedPrice]);

      		setAddedPrices((prev) => {
				if(!prev.find(price => price.acommodation_description === selectedPrice.acommodation_description)) {
					return [...prev, selectedPrice]
				}
				return prev;
			});

			setSelectedPricesOut((prev) =>
				prev.filter((price) => price.acommodation_description !== accommodationDescription)
			);

			setSelectedPricesDaily((prev) => [...prev, ...selectedPriceDaily]);

			setSelectedPricesDailyOut((prev) =>
				prev.filter((price) => price.acommodation_description !== accommodationDescription)
			)
			setAddedPricesDaily((prev) => {
				if(!prev.find(price => price.acommodation_description === selectedPrice.acommodation_description)) {
					return [...prev, ...selectedPriceDaily]
				}
				return prev;
			});
		}
	}, [selectedPricesOut]);

const handleRemovePriceOut = useCallback((accommodationDescription) => {
	const removedPrice = selectedPrices.find(
		(price) => price.acommodation_description === accommodationDescription
	);

	const removedPriceDaily = selectedPricesDaily.filter(
		(price) => price.acommodation_description === accommodationDescription
	);

	if (removedPrice && removedPriceDaily.length > 0) {
		setSelectedPricesOut((prev) => [...prev, removedPrice]);
		setSelectedPricesDailyOut((prev) => [...prev, ...removedPriceDaily]);

		setSelectedPrices((prev) =>
			prev.filter((price) => price.acommodation_description !== accommodationDescription)
		);

		setSelectedPricesDaily((prev) =>
			prev.filter((price) => price.acommodation_description !== accommodationDescription)
		);

		setAddedPrices((prev) =>
			prev.filter((price) => price.acommodation_description !== accommodationDescription)
		);

		setAddedPricesDaily((prev) =>
			prev.filter((price) => price.acommodation_description !== accommodationDescription)
		);
	}
}, [selectedPrices, selectedPricesDaily]);

  const formatPrice = (price) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price);

  const handleCancel = useCallback(() => setIsForm(false), [setIsForm]);
  const handleSubmit = useCallback(async (budget_type) => {
    let details;

    const budgetRequestData = (budget_type == 1 || budget_type == '1') ? budgetRequest : budgetRequestCanalDireto

    if(budget_type == 2){
      details = budgets.map((budget) => ({
        check_in: budget.check_in,
        check_out: budget.check_out,
        adults_quantity: budget.adults_quantity,
        children_quantity: budget.children_quantity,
        babies_quantity: budget.babies_quantity,
        agencia: budgetRequestData.budgetAgencia,
        executivo: budgetRequestData.budgetExecutivo,
        estado: budgetRequestData.budgetEstado,
        midia: budgetRequestData.budgetMidia,
        prices: budget.prices.map((price) => ({
          uh_type: price.acommodation_description,
          date: price.acommodation_date,
          id_tarifa: price.tax_id || 0,
          price: price.total_cost_accomodation,
          discount: 0,
          flg_nao_disponivel: price.flg_nao_disponivel,
          flg_uh_unica: false,
        })),
        prices_daily: budget.prices_daily,
      }));
    }else {
      details = budgets.map((budget) => ({
        check_in: budget.check_in,
        check_out: budget.check_out,
        adults_quantity: budget.adults_quantity,
        children_quantity: budget.children_quantity,
        babies_quantity: budget.babies_quantity,
        midia: budgetRequestData.budgetMidia,
        // id_motivo_cancelamento: budgetRequestData.id_motivo_cancelamento === 0 ? null : budgetRequestData.id_motivo_cancelamento,
        prices: budget.prices.map((price) => ({
          uh_type: price.acommodation_description,
          date: price.acommodation_date,
          id_tarifa: price.tax_id || 0,
          price: price.total_cost_accomodation,
          discount: 0,
          flg_nao_disponivel: price.flg_nao_disponivel,
          flg_uh_unica: false,
        })),
        prices_daily: budget.prices_daily,
      }));
    }

    const budgetObject = {
      mail: mail.body,
      clerk: getUserName(),
      client: {
        name: mail.clientName,
        email: mail.clientEmail,
        phone: mail.clientPhone,
      },
      hash: hashBudgets,
      details,
      id_status: budgetRequestData.budgetMotivo,
      observacoes: budgetRequestData.budgetObservacao,
      budget_type: budget_type
    };

    try {

      if (!mail.clientNameError && !mail.clientPhoneError) {
        const response = await createBudget(budgetObject);

        console.log("CREATE BUDGET",response)
       
        const orcamentoSubject = {
          "pt": "Segue seu orçamento",
          "en": "Here is your budget",
          "es": "Aquí está su presupuesto"
        }

        if (response.success) {
          if(!mail.clientEmailError && mail.clientEmail){
            await sendEmail({
              operatorId: getUserId(),
              to: mail.clientEmail,
              cc: mail.copyEmail,
              subject: orcamentoSubject[emailLanguage],
              mailBody: mail.body,
              attachments: mail.attachments,
            });
          }
          window.location.href = "/orcamentos/" + ((budget_type == 1 || budget_type == '1') ? "call-center" : "canal-do-agente");
        } else {
          alert('Erro ao criar o Orçamento tente novamente por favor')
        }
      } else {
        alert('Erros no formulário preencha corretamente por favor');
      }

    } catch (e) {}
  }, [mail, budgets, budgetRequest, budgetRequestCanalDireto]);

  const handleSubmitPayLink = useCallback(async (accommodationDescription, paymentTypeId, budget_type) => {
    const details = budgets.map((budget) => ({
      check_in: budget.check_in,
      check_out: budget.check_out,
      adults_quantity: budget.adults_quantity,
      children_quantity: budget.children_quantity,
      babies_quantity: budget.babies_quantity,
      midia: budgetRequest.budgetMidiaError ? null : budgetRequest.budgetMidia,
      prices: budget.prices.map((price) => {
        const isPaymentAccommodation =
          price.acommodation_description === accommodationDescription;

        return {
          uh_type: price.acommodation_description,
          date: price.acommodation_date,
          id_tarifa: price.tax_id || 0,
          price: price.total_cost_accomodation,
          discount: 0,
          flg_nao_disponivel: price.flg_nao_disponivel,
          flg_uh_unica: isPaymentAccommodation,
          id_payment_type: isPaymentAccommodation ? parseInt(paymentTypeId) : null
        };
      }),
      prices_daily: budget.prices_daily.map((dailyPrice) => {
        return {
          ...dailyPrice,
          daily_price: Number(dailyPrice.daily_price),
          daily_price_with_tax:
            Number(dailyPrice.daily_price) * hotelTax,
          discounts_applied: [
            ...(dailyPrice.discounts_applied || []),
            // Temporariamente desabilitado: registro do desconto da política de pagamento.
            // ...(isPaymentAccommodation && paymentDiscountFraction > 0
            //   ? [{
            //       type: 'PAYMENT_POLICY',
            //       reference_id: parseInt(paymentTypeId),
            //       discount: paymentDiscountFraction * 100,
            //       total_discount: paymentDiscount,
            //     }]
            //   : []),
          ],
        };
      }),
    }));

    const budgetObject = {
      mail: mail.body,
      clerk: getUserName(),
      client: {
        name: mail.clientName,
        email: mail.clientEmail,
        phone: mail.clientPhone,
      },
      hash: hashBudgets,
      details,
      budget_type: budget_type,
      id_status: budgetRequest.budgetMotivoError ? null : budgetRequest.budgetMotivo,
      observacoes: budgetRequest.budgetObservacao,
    };

    try {

      if (!mail.clientNameError) {
        const response = await createBudget(budgetObject);

        console.log("CREATE BUDGET",response)

        if (response.success) {

          const message_type = accommodationDescription && paymentTypeId ? 'pay' : 'budget'

          if(!mail.clientEmailError && mail.clientEmail){

            const emailBudgets = budgets.map((budget) => {
              new Date(budget.check_in)
              const roomnights = (budget.check_out - budget.check_in) / (1000 * 60 * 60 * 24)

              const checkin = format(budget.check_in, "dd/MM/yyyy")
              const checkout = format(budget.check_out, "dd/MM/yyyy")

              return {
                check_in: checkin,
                check_out: checkout,
                adults_quantity: budget.adults_quantity,
                children_quantity: budget.children_quantity,
                babies_quantity: budget.babies_quantity,
                roomnights: roomnights.toString(),
                prices: budget.prices.map((price) => ({
                  uh_type: price.acommodation_description,
                  price: formatPrice(price.total_cost_accomodation),
                })),
            }});

            const emailData = {
              name: mail.clientName,
              hash: hashBudgets,
              budgets: emailBudgets,
              default_discount: defaultDiscount,
              non_refundable_discount_pix: nonRefundableDiscountPix,
              non_refundable_discount_card: nonRefundableDiscountCard,
            }

            const orcamentoSubject = message_type === 'pay' ? "Confirme sua reserva" : "Segue seu orçamento"

            await sendEmailTemplate({
              operatorId: getUserId(),
              to: mail.clientEmail,
              subject: orcamentoSubject,
              data: emailData,
              message_type: message_type
            });
          }

          if(!mail.clientPhoneError){

            const budgetComMenorCusto = budgets.reduce((menor, atual) => {
              const menorCusto = Math.min(...menor.prices.map(p => p.total_cost_accomodation));
              const atualCusto = Math.min(...atual.prices.map(p => p.total_cost_accomodation));

              return atualCusto < menorCusto ? atual : menor;
            }, budgets[0]);

            const menorValor1RN = Math.min(
              ...budgetComMenorCusto.prices_daily.map(p => p.daily_price)
            );

            const numeroHospedes = 
              budgetComMenorCusto.adults_quantity +
              budgetComMenorCusto.children_quantity +
              budgetComMenorCusto.babies_quantity;

            await sendMessage({
              from: "+554832611551",
              to: mail.clientPhone.replaceAll(' ', ''),
              message_type: message_type,
              variables: {
                "1": mail.clientName,
                "2": format(budgetComMenorCusto.check_in, "dd/MM/yyyy"),
                "3": format(budgetComMenorCusto.check_out, "dd/MM/yyyy"),
                "4": numeroHospedes.toString(),
                // "5": menorValor1RN.toString(),
                "6": hashBudgets
              },
            });
          }
          
          window.location.href = "/orcamentos/" + ((budget_type == 1 || budget_type == '1') ? "call-center" : "canal-do-agente");
        } else {
          alert('Erro ao criar o Orçamento tente novamente por favor')
        }
      } else {
        alert('Erros no formulário preencha corretamente por favor');
      }
    } catch (e) {}
  }, [mail, budgets, budgetRequest, paymentTypes]);

  const addToBudget = useCallback(() => {

    console.log(selectedPrices.map((price) => price.children_free), Math.max.apply(
      Math,
      selectedPrices.map((price) => price.children_free)
    ))

    const newBudget = {
      ...params,
      check_in: stringToDate(selectedDates[0]),
      check_out: addDays(stringToDate(selectedDates[selectedDates.length - 1]), 1),
      prices: selectedPrices,
      prices_daily: selectedPricesDaily,
      children_free: Math.max.apply(
        Math,
        selectedPrices.map((price) => price.children_free)
      ),
      min_room_night_children_free: selectedDates.length >= Math.max.apply(
        Math,
        selectedPrices.map((price) => price.min_room_night_children_free)
      ) ? true : false,
      extras: extras || 0,
    };

    setBudgets([...budgets, newBudget]);
	setSelectedPrices([]);
	setSelectedPricesDaily([]);
  }, [params, budgets, selectedPrices]);

  const removeFromBudget = useCallback(
    (indexOf) => {
      setBudgets(budgets.filter((_, i) => i !== indexOf));
    },
    [budgets]
  );

  const handleSearch = useCallback(async () => {
    const check_in = format(params.check_in, "dd/MM/yyyy");
    const check_out = format(params.check_out, "dd/MM/yyyy");
    const check_in15 = format(addDays(params.check_in, -15), "dd/MM/yyyy");
    const check_out15 = format(addDays(params.check_out, 14), "dd/MM/yyyy");
    setSelectedDates(createDatesArr(params.check_in, params.check_out));
    setLoading(true);
    await fetchData({
      ...params,
      check_in,
      check_out,
      check_in15,
      check_out15,
    });

    setLoading(false);

    // setRange([data.dates.indexOf(check_in), data.dates.indexOf(check_out)]);
  }, [data.dates, params, fetchData]);

  const handleSubmitBudgetRequest = useCallback(async (budget_type) => {
    let details;

    const budgetRequestData = (budget_type == 1 || budget_type == '1') ? budgetRequest : budgetRequestCanalDireto

    if(budget_type == 2){
      details = budgets.map((budget) => ({
        check_in: budget.check_in,
        check_out: budget.check_out,
        adults_quantity: budget.adults_quantity,
        children_quantity: budget.children_quantity,
        babies_quantity: budget.babies_quantity,
        agencia: budgetRequestData.budgetAgencia,
        executivo: budgetRequestData.budgetExecutivo,
        estado: budgetRequestData.budgetEstado,
        midia: budgetRequestData.budgetMidia,
        prices: budget.prices.map((price) => ({
          uh_type: price.acommodation_description,
          date: price.acommodation_date,
          id_tarifa: price.tax_id || 0,
          price: price.total_cost_accomodation,
          discount: 0,
          flg_nao_disponivel: price.flg_nao_disponivel,
          flg_uh_unica: false,
        })),
        prices_daily: budget.prices_daily,
      }));
    }else {
      details = budgets.map((budget) => ({
        check_in: budget.check_in,
        check_out: budget.check_out,
        adults_quantity: budget.adults_quantity,
        children_quantity: budget.children_quantity,
        babies_quantity: budget.babies_quantity,
        midia: budgetRequestData.budgetMidia,
        // id_motivo_cancelamento: budgetRequestData.id_motivo_cancelamento === 0 ? null : budgetRequestData.id_motivo_cancelamento,
        prices: budget.prices.map((price) => ({
          uh_type: price.acommodation_description,
          date: price.acommodation_date,
          id_tarifa: price.tax_id || 0,
          price: price.total_cost_accomodation,
          discount: 0,
          flg_nao_disponivel: price.flg_nao_disponivel,
          flg_uh_unica: false,
        })),
        prices_daily: budget.prices_daily,
      }));
    }

    const budgetObject = {
      mail: null,
      clerk: getUserName(),
      client: {
        name: mail.clientName,
        email: mail.clientEmail,
        phone: mail.clientPhone,
      },
      hash: hashBudgets,
      details,
      id_status: budgetRequestData.budgetMotivo,
      observacoes: budgetRequestData.budgetObservacao,
      budget_type: budget_type
    };

    try {
      const response = await createBudget(budgetObject);

      console.log("CREATE BUDGET",response)

      if (response.success) {

        window.location.href = "/orcamentos/" + ((budget_type == 1 || budget_type == '1') ? "call-center" : "canal-do-agente");
      } else {
        alert('Erro ao criar o Orçamento tente novamente por favor')
      }

    } catch (e) {}
  }, [mail, budgets, budgetRequest, budgetRequestCanalDireto]);

  const handleNextStep = useCallback(() => {
    const newStep = Object.values(STEP)[step + 1];
    setStep(newStep);
  }, [step]);

  const handleBackStep = useCallback(() => {
    const newStep = Object.values(STEP)[step - 1];
    setStep(newStep);
  }, [step]);

  const [emailLanguage, setEmailLanguage] = useState('pt');

  const value = useMemo(
    () => ({
      data,
      step,
      loading,
      selectedPrices,
	    selectedPricesOut,
      selectedPricesDaily,
	    selectedPricesDailyOut,
      mail,
      budgets,
      params,
      selectedDates,
      checkedRules,
      changeParams,
      changeMail,
      budgetRequest, changeBudgetRequestForm,
      budgetRequestCanalDireto, changeBudgetRequestFormCanalDireto,
      handleCancel,
      handleSubmit,
      handleSubmitBudgetRequest,
      handleSubmitPayLink,
      handleSearch,
      handleNextStep,
      handleBackStep,
      handleAddPriceOut,
      handleRemovePriceOut,
      addToBudget,
      removeFromBudget,
      setExtras,
      setDiscount,
      setSelectedDates,
      setCheckedRules,
      defaultDiscount,
      defaultPercentualDiscount,
      nonRefundableDiscount,
      nonRefundablePercentualDiscount,
      nonRefundableDiscountPix,
      nonRefundableDiscountCard,
      paymentTypes,
      extras,
      formType,
      setPercDiscount,
      setDiscountInput,
      hashBudgets, // Adicionando hashBudgets ao contexto
      emailLanguage,
      setEmailLanguage,
      activeCategory,
      pricesToProcess,
      stayLength,
      lowestPossibleCategory
    }),
    [
      data,
      step,
      loading,
      selectedPrices,
      selectedPricesOut,
      selectedPricesDaily,
      selectedPricesDailyOut,
      selectedDates,
      checkedRules,
      mail,
      budgets,
      params,
      changeMail,
      budgetRequest, changeBudgetRequestForm,
      budgetRequestCanalDireto, changeBudgetRequestFormCanalDireto,
      handleCancel,
      handleSubmit,
      handleSubmitBudgetRequest,
      handleSubmitPayLink,
      handleSearch,
      handleNextStep,
      handleBackStep,
      handleAddPriceOut,
      handleRemovePriceOut,
      removeFromBudget,
      addToBudget,
      defaultDiscount,
      defaultPercentualDiscount,
      nonRefundableDiscount,
      nonRefundablePercentualDiscount,
      nonRefundableDiscountPix,
      nonRefundableDiscountCard,
      paymentTypes,
      extras,
      formType,
      hashBudgets, // Incluindo hashBudgets nas dependências
      activeCategory,
      pricesToProcess,
      stayLength,
      lowestPossibleCategory
    ]
  );

  return (
    <BudgetFormContext.Provider value={value}>
      {children}
    </BudgetFormContext.Provider>
  );
};

//Hook que será utilizando nos componentes para acesso ao contexto
export const useBudgetFormContext = () => useContext(BudgetFormContext);

export default BudgetFormContextProvider;